<!--
 * @Description: 
 * @Author: 景 彡
 * @Date: 2023-05-25 10:46:01
 * @LastEditors: 景 彡
-->
<script setup lang="ts">
import { ref, shallowRef, watch } from 'vue';
import type { Rule } from 'ant-design-vue/lib/form';
import { Form as CForm, FormItem as CFormItem } from '../../form';
import type { FormField } from '../types';
import FormChild from './_FormItem.vue';

const props = withDefaults(
  defineProps<{
    fields: FormField[];
    value: { [key: string]: any };
  }>(),
  {
    fields: () => [],
    value: () => ({}),
  }
);

const _fields = shallowRef<FormField[]>([]);

watch(
  () => props.fields,
  val => {
    _fields.value = [];
    val.forEach(field => {
      const value = field;
      if (!value.formItem?.rules) {
        if (!value.formItem) value.formItem = {};
        value.formItem.rules = value.rules;
      }

      if (field.required) {
        let rule = { required: true, message: `${field.label}必填!` };
        if (typeof field.required === 'string') {
          rule = { required: true, message: field.required };
        }
        if (Array.isArray(value.formItem.rules)) {
          value.formItem.rules = [rule, ...(value.formItem?.rules || [])];
        } else if (!value.formItem.rules) {
          value.formItem.rules = rule;
        }
      }

      if (field.type === 'email') {
        value.formItem.rules = [{ required: true, validator: validateEmail, trigger: 'change' }];
      }
      if (field.type === 'phone') {
        value.formItem.rules = [{ required: true, validator: validatePhone, trigger: 'change' }];
      }
      if (field.type === 'idNo') {
        value.formItem.rules = [{ required: true, validator: validateIdNo, trigger: 'change' }];
      }
      _fields.value.push(value);
    });
  },
  { immediate: true }
);

async function validateEmail(_rule: Rule, value: string) {
  if (!value || value === '') return Promise.reject('请输入邮箱!');
  if (value && !/\S+@\S+\.\S+/.test(value)) {
    return Promise.reject('请输入正确的邮箱!');
  }
  return Promise.resolve();
}

async function validatePhone(_rule: Rule, value: string) {
  if (!value || value === '') return Promise.reject('请输入手机号!');
  if (value && !/^1\d{10}$/.test(value)) {
    return Promise.reject('请输入正确的手机号!');
  }
  return Promise.resolve();
}

async function validateIdNo(_rule: Rule, value: string) {
  const idNumReg1 = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

  if (!value || value === '') return Promise.reject('请输入身份证号!');
  if (value && !idNumReg1.test(value)) {
    return Promise.reject('请输入正确的身份证号码!');
  }
  return Promise.resolve();
}

const _value = ref(props.value);

watch(
  () => props.value,
  () => {
    _value.value = props.value;
  }
);

const proFormRef = ref<InstanceType<typeof CForm>>();

function getFormRef() {
  return proFormRef.value?.elRef;
}

async function validate() {
  return await proFormRef.value?.elRef?.validate();
}

function resetForm() {
  return proFormRef.value?.elRef?.resetFields();
}

defineExpose({
  getFormRef,
  validate,
  resetForm,
});
</script>

<script lang="ts">
export default {
  name: 'ProForm',
};
</script>

<template>
  <c-form ref="proFormRef" :model="_value">
    <c-form-item v-for="item in _fields" :key="item.prop" :label="item.label" :name="item.prop" v-bind="item.formItem">
      <FormChild :field="item" :model="_value" />
    </c-form-item>
    <c-form-item :wrapper-col="{ offset: 2, span: 16 }">
      <slot name="footer"> </slot>
    </c-form-item>
  </c-form>
</template>
